// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1leSY","leftWrapper":"i9mI6","heading":"_2KolG","subHeading":"_3ITyK","imageContainer":"_3v87Q"};